//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import CollectionId from '@models/CollectionId';

// A largely incomplete set of types for the collections code, please add on here
// as we clean up these old files!

export interface ICollection {
  name: string;
  id: CollectionId;
}

export interface ICollectionState {
  view: CONTENT_COLLECTION_CONTEXTS;
  params: CollectionStateParams;
}

interface CollectionStateParams {
  collectionId?: string;
}

export enum CONTENT_COLLECTION_CONTEXTS {
  TEAM_MEDIA = 'library.team-media',
  MY_MEDIA = 'library.my-media',
  ALL_MEDIA = 'library.all-media',
  COLLECTIONS = 'library.collections.content',
  TRACKED_SOURCES = 'library.tracked-sources.user',
}
